module.exports = __webpack_public_path__ + "static/media/add.6afb7965.svg";